import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// import pages
import Home from "./pages/Home";
import PropertyDetails from "./pages/PropertyDetails";
import PropertyType from "./pages/PropertyType";


//dashboard
import DashboardHome from "./pages/Dashboard/DashboardHome";

//dashboard/property
import PropertyCreate from "./pages/Dashboard/Property/PropertyCreate";
import PropertyEdit from "./pages/Dashboard/PropertyEdit/PropertyEdit";
import PropertyList from "./pages/Dashboard/Property/PropertyList";

// dashboard/alquileres
import AlquileresOverview from "./pages/Dashboard/Alquileres/AlquileresOverview/AlquileresOverview";
import ContratoList from "./pages/Dashboard/Alquileres/ContratoList/ContratoList";
import ContratoCreate from "./pages/Dashboard/Alquileres/ContratoCreate/ContratoCreate";
import ContratoEdit from "./pages/Dashboard/Alquileres/ContratoEdit/ContratoEdit";
import LocadorList from "./pages/Dashboard/Alquileres/LocadorList/LocadorList";
import LocatarioList from "./pages/Dashboard/Alquileres/LocatarioList/LocatarioList";
import Liquidacion from "./pages/Dashboard/Alquileres/Liquidacion/Liquidacion";
import Aumentos from "./pages/Dashboard/Alquileres/Aumentos/Aumentos";
import AlquileresConfig from "./pages/Dashboard/Alquileres/AlquileresConfig/AlquileresConfig";
import ImportContratos from "./pages/Dashboard/Alquileres/ImportContratos/ImportContratos";
import Cobros from "./pages/Dashboard/Alquileres/Cobros/Cobros";
import Gastos from "./pages/Dashboard/Alquileres/Gastos/Gastos";
import Indices from "./pages/Dashboard/Alquileres/Indices/Indices";
import Reportes from "./pages/Dashboard/Alquileres/Reportes/Reportes";
import AlquileresLoadingGuard from "./components/LoadingState/AlquileresLoadingGuard";
import PropertiesLoadingGuard from "./components/LoadingState/PropertiesLoadingGuard";
import DashboardLoadingGuard from "./components/LoadingState/DashboardLoadingGuard";

import Login from "./pages/Login";
import { AuthContextProvider } from "./context/authContext";
import PublicRoute from "./router/PublicRoute";
import PrivateRoute from "./router/PrivateRoute";
import ProyectView from "./pages/ProyectView";
import Proyects from "./pages/Proyects";
import PropertiesMap from "./pages/PropertiesMap";
import PropertyFeatured from "./pages/Dashboard/Property/PropertyFeatured";
import PropertyCartel from "./pages/Dashboard/Property/PropertyCartel";
import Notas from "./pages/Dashboard/Notas";
import Actividad from "./pages/Dashboard/Actividad";

// Configuración de Google Analytics
const GA_TRACKING_ID = "G-67ZE98NGGZ";

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Cargar el script de Google Analytics
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_TRACKING_ID}');
    `;
    document.head.appendChild(script2);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", { page_path: location.pathname });
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <AuthContextProvider>
      <BrowserRouter>
        <GoogleAnalytics />
        <Routes>
          <Route path="/" element={<PublicRoute />}>
            <Route index element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/propiedad/:id" element={<PropertyDetails />} />
            <Route path="/tipo/:type" element={<PropertyType />} />
            <Route path="/mapa" element={<PropertiesMap />} />
            <Route path="proyectos" element={<Proyects />} />
            <Route path="proyectos/:id" element={<ProyectView />} />
          </Route>

          <Route path="/dashboard/*" element={<PrivateRoute />}>
            <Route
              index
              element={
                <DashboardLoadingGuard>
                  <DashboardHome />
                </DashboardLoadingGuard>
              }
            />

            {/* Propiedades - all wrapped in the loading guard */}
            <Route path="propiedades" element={<PropertiesLoadingGuard />}>
              <Route index element={<PropertyList />} />
              <Route path="agregar" element={<PropertyCreate />} />
              <Route path="destacadas" element={<PropertyFeatured />} />
              <Route path="editar/:id" element={<PropertyEdit />} />
              <Route path="cartel/:id" element={<PropertyCartel />} />
            </Route>

            <Route path="notas" element={<Notas />} />
            <Route path="actividad" element={<Actividad />} />

            {/* Alquileres - all wrapped in the loading guard */}
            <Route path="alquileres" element={<AlquileresLoadingGuard />}>
              <Route index element={<AlquileresOverview />} />
              <Route path="contratos" element={<ContratoList />} />
              <Route path="contratos/nuevo" element={<ContratoCreate />} />
              <Route path="contratos/editar/:id" element={<ContratoEdit />} />
              <Route path="locadores" element={<LocadorList />} />
              <Route path="locatarios" element={<LocatarioList />} />
              <Route path="liquidacion" element={<Liquidacion />} />
              <Route path="aumentos" element={<Aumentos />} />
              <Route path="indices" element={<Indices />} />
              <Route path="reportes" element={<Reportes />} />
              <Route path="cobros" element={<Cobros />} />
              <Route path="gastos" element={<Gastos />} />
              <Route path="configuracion" element={<AlquileresConfig />} />
              <Route path="importar" element={<ImportContratos />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthContextProvider>
  );
}

export default App;
